import axios from 'axios'
import { DESBLOQUEAR_AGENCIA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idAgencia, idEmpresa) => dispach =>
  axios.get(`${URL}/agencia/${idAgencia}/empresa/${idEmpresa}/desbloquear`,SLOW_REQUEST_CONFIG)
    .then( reponse => dispach({
        type: DESBLOQUEAR_AGENCIA,
        payload: reponse
  }));
